import {Utils} from "./Utils";

type ColorScheme = {
    [key: string]: string[]
};

interface DemopanelConfig {
    colors?: ColorScheme
}

export class Demopanel {
    protected html: HTMLElement;
    protected blockNameState: string;
    protected blockNameTrigger: HTMLInputElement;
    protected blockNameElements: NodeListOf<HTMLElement>;
    protected colors: ColorScheme;
    private options: {
        [key: string]: NodeListOf<HTMLElement>
    };

    constructor({colors}: DemopanelConfig)  {
        this.html = document.documentElement;
        this.colors = colors;
        this.options = {};
    }

    protected static findColor(arr: string[], i: number): string {
        return arr[i] ? arr[i] : arr[0];
    }

    public addOptions(element: string, type: string): void {
        const elements: NodeListOf<HTMLElement> = document.querySelectorAll(element);
        if (!elements.length) return;

        this.options[type] = elements;
        this.options[type].forEach(element => {
            element.addEventListener(`click`, () => this.onOptionClick(element, type));
        });
    }

    protected onOptionClick(element: HTMLElement, type: string): void {
        const value = element.getAttribute(`data-value`);
        this.options[type].forEach(element => element.classList.remove(`is-active`));
        element.classList.add(`is-active`);

        if (type === `shadow`) this.changeShadowScheme(value);
        if (type === `color`) this.changeColorScheme(value);
    }

    public changeShadowScheme(number: string): void {
        Utils.removeClassByPrefix(this.html, `shadow-`);
        this.html.classList.add(`shadow-${number}`);
    }

    public changeColorScheme(number: string): void {
        if (!this.colors) return;

        const i = +number - 1;
        const c = this.colors;

        this.html.style.cssText = `
            --primary: ${Demopanel.findColor(c.primary, i)};
            --primary-light: ${Demopanel.findColor(c.primary_light, i)};
            --primary-dark: ${Demopanel.findColor(c.primary_dark, i)};
            --secondary: ${Demopanel.findColor(c.secondary, i)};
            --secondary-light: ${Demopanel.findColor(c.secondary_light, i)};
            --secondary-dark: ${Demopanel.findColor(c.secondary_dark, i)};
            --background: ${Demopanel.findColor(c.background, i)};
            --inverse: ${Demopanel.findColor(c.inverse, i)};
            --text: ${Demopanel.findColor(c.text, i)};
            --text-light: ${Demopanel.findColor(c.text_light, i)};
            --text-soft: ${Demopanel.findColor(c.text_soft, i)};
            --text-inverse: ${Demopanel.findColor(c.text_inverse, i)};
        `;
    }

    public setBlockNameSwitch(trigger: string, elements: string): void {
        this.blockNameTrigger = document.querySelector(trigger);
        this.blockNameElements = document.querySelectorAll(elements);
        this.blockNameState = Utils.getCookie(`themesettings_blocknames`);

        if (!this.blockNameTrigger || !this.blockNameElements.length) return;
        if (this.blockNameState === `1`) this.showBlockNames();
        this.blockNameTrigger.addEventListener(`click`, () => this.onBlockNameSwitch());
    }

    protected onBlockNameSwitch(): void {
        this.toggleBlockNames();
    }

    protected showBlockNames(): void {
        this.blockNameTrigger.checked = true;
        this.blockNameElements.forEach( it => it.classList.add(`is-active`));
    }

    public toggleBlockNames(): void {
        const newState = (this.blockNameState === `1`) ? `0` : `1`;
        this.blockNameState = newState;
        Utils.setCookie(`themesettings_blocknames`, newState);

        if (!this.blockNameElements.length) return;
        this.blockNameElements.forEach( it => {
            it.classList.toggle(`is-active`);
        });
    }
}